// @ts-strict-ignore
const xmlParser = new DOMParser();
export class XMLElement {
    public constructor(public elem: any) { }
    public attr(name: string): string | null { return this.elem.getAttribute(name); }
    public text(): string | null { return this.elem.textContent; }
    public get tagName(): string { return this.elem.tagName; }
    public children(): XMLElements { return new XMLElements(Array.from(this.elem.children).map((elem: Element) => { return new XMLElement(elem); })); }
    public prop(name: string): any { return this.elem[name]; }
    public find(selector: string): XMLElements {
        const doc = selector.includes("xmlns") ? xmlParser.parseFromString(this.elem.outerHTML, "text/html") : this.elem;
        return new XMLElements(Array.from(doc.querySelectorAll(selector)).map((elem: Element) => { return new XMLElement(elem); }));
    }
}

export class XMLElements {
    public constructor(public elems: XMLElement[]) { }
    public forEach(callbackfn: (value: XMLElement, index: number, array: XMLElement[]) => void): void { this.elems.forEach(callbackfn); }

    /**
     * Forward the array iterator, which allow to do this
     *
     * ```ts
     * const parent: XMLElement = getParent()
     * const elements: XMLElements = parent.children()
     * for (const element of elements) {
     *   // do things
     * }
     * ```
     *
     * The method behave the same way as `forEach`. Here is the equivalent:
     * ```ts
     * const parent: XMLElement = getParent()
     * const elements: XMLElements = parent.children()
     * elements.forEach((element) => {
     *   // do things
     * })
     * ```
     *
     * The main advantage of using an iterator is that we can use promise and async/await with
     * it nativelly, where the `forEach` can't without causing side-effects.
     *
     * Here is the [Iterator documentation](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Iterators_and_generators)
     * @returns
     */
    public [Symbol.iterator]() { return this.elems[Symbol.iterator](); }
    public some(callbackfn: any): boolean { return this.elems.some(callbackfn); }
    public map<T>(callbackfn: any): T[] { return this.elems.map<T>(callbackfn); }
    public attr(name: string): string | null { return this.elems.length ? this.elems[0].attr(name) : null; }
    public text(): string | null { return this.elems.length ? this.elems[0].text() : null; }
    public find(selector: string): XMLElements { return this.elems.length ? this.elems[0].find(selector) : new XMLElements([]); }
    public first(): XMLElement | null { return this.elems.length ? this.elems[0] : null; }
    public prop(name: string): any { return this.elems.length ? this.elems[0].elem[name] : undefined; }
    get length(): number { return this.elems.length; }
}

export default (element: any, ns: DOMParserSupportedType = "application/xml"): XMLElement => {
    if (typeof element !== "string") return new XMLElement(element);
    return new XMLElement(xmlParser.parseFromString(element, ns));
};
